import { Anchor, Box, Center, Paper, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';
import { SUPPORT_EMAIL } from '@creativitas/shared';
import { BRAND } from '@/lib/assets';

type AuthLayoutProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
};

/** Calm, centred card for the two unauthenticated screens. Works down to mobile (§57). */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <Center mih="100dvh" p="md" style={{ background: 'var(--surface-page)' }}>
      <Stack gap="lg" w="100%" maw={420}>
        <Stack gap="xs" align="center">
          <img src={BRAND.sunMark} alt="" width={40} height={40} />
          <Title order={2} ta="center">
            {title}
          </Title>
          {subtitle ? (
            <Text size="sm" c="var(--text-muted)" ta="center" maw={340}>
              {subtitle}
            </Text>
          ) : null}
        </Stack>

        <Paper withBorder p="lg" radius="lg" style={{ borderColor: 'var(--border-subtle)' }}>
          {children}
        </Paper>

        {footer ? <Box ta="center">{footer}</Box> : null}

        {/*
          Поддержка видна на каждом экране входа, а не только внутри платформы:
          тот, кому не дошло письмо, внутрь как раз и не попадает. Почтовик
          получателя может отклонить письмо, и ни повторная отправка, ни
          восстановление тогда не помогут — помочь может только человек.
        */}
        <Text size="xs" c="var(--text-muted)" ta="center">
          Не пришло письмо или не получается войти? Проверьте папку «Спам», а если
          там пусто — напишите нам:{' '}
          <Anchor href={`mailto:${SUPPORT_EMAIL}`} size="xs">
            {SUPPORT_EMAIL}
          </Anchor>
        </Text>
      </Stack>
    </Center>
  );
}
